import z from "./atoms-v21165.js";
import * as v from "react";
import D from "./atoms-v21234.js";
import { getRegisteredStyles as A, registerStyles as I, insertStyles as V } from "./atoms-v21235.js";
import { serializeStyles as x } from "./atoms-v21141.js";
import { useInsertionEffectAlwaysWithSyncFallback as L } from "./atoms-v21236.js";
import { w as Y, T as U } from "./atoms-v21237.js";
var q = D, J = function(e) {
  return e !== "theme";
}, O = function(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96 ? q : J;
}, C = function(e, n, s) {
  var r;
  if (n) {
    var a = n.shouldForwardProp;
    r = e.__emotion_forwardProp && a ? function(l) {
      return e.__emotion_forwardProp(l) && a(l);
    } : a;
  }
  return typeof r != "function" && s && (r = e.__emotion_forwardProp), r;
}, b = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, W = function(e) {
  var n = e.cache, s = e.serialized, r = e.isStringTag;
  return I(n, s, r), L(function() {
    return V(n, s, r);
  }), null;
}, K = function f(e, n) {
  if (process.env.NODE_ENV !== "production" && e === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var s = e.__emotion_real === e, r = s && e.__emotion_base || e, a, l;
  n !== void 0 && (a = n.label, l = n.target);
  var y = C(e, n, s), E = y || O(r), S = !E("as");
  return function() {
    var i = arguments, u = s && e.__emotion_styles !== void 0 ? e.__emotion_styles.slice(0) : [];
    if (a !== void 0 && u.push("label:" + a + ";"), i[0] == null || i[0].raw === void 0)
      u.push.apply(u, i);
    else {
      process.env.NODE_ENV !== "production" && i[0][0] === void 0 && console.error(b), u.push(i[0][0]);
      for (var F = i.length, m = 1; m < F; m++)
        process.env.NODE_ENV !== "production" && i[0][m] === void 0 && console.error(b), u.push(i[m], i[0][m]);
    }
    var o = Y(function(t, d, T) {
      var g = S && t.as || r, c = "", P = [], _ = t;
      if (t.theme == null) {
        _ = {};
        for (var w in t)
          _[w] = t[w];
        _.theme = v.useContext(U);
      }
      typeof t.className == "string" ? c = A(d.registered, P, t.className) : t.className != null && (c = t.className + " ");
      var N = x(u.concat(P), d.registered, _);
      c += d.key + "-" + N.name, l !== void 0 && (c += " " + l);
      var R = S && y === void 0 ? O(g) : E, p = {};
      for (var h in t)
        S && h === "as" || // $FlowFixMe
        R(h) && (p[h] = t[h]);
      return p.className = c, p.ref = T, /* @__PURE__ */ v.createElement(v.Fragment, null, /* @__PURE__ */ v.createElement(W, {
        cache: d,
        serialized: N,
        isStringTag: typeof g == "string"
      }), /* @__PURE__ */ v.createElement(g, p));
    });
    return o.displayName = a !== void 0 ? a : "Styled(" + (typeof r == "string" ? r : r.displayName || r.name || "Component") + ")", o.defaultProps = e.defaultProps, o.__emotion_real = o, o.__emotion_base = r, o.__emotion_styles = u, o.__emotion_forwardProp = y, Object.defineProperty(o, "toString", {
      value: function() {
        return l === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + l;
      }
    }), o.withComponent = function(t, d) {
      return f(t, z({}, n, d, {
        shouldForwardProp: C(o, d, !0)
      })).apply(void 0, u);
    }, o;
  };
};
export {
  K as default
};
